{
  "version": 1,
  "asset_id": "571c98b7-103b-43aa-b0f2-7543b4a130e9",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/571c98b7-103b-43aa-b0f2-7543b4a130e9/logo-google.png",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/571c98b7-103b-43aa-b0f2-7543b4a130e9/logo-google.png",
  "original_filename": "logo-google.png",
  "size": 3831,
  "content_type": "image/png",
  "created_at": "2026-09-04T14:19:00Z"
}
